/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import AppliedLettersPresenter from './AppliedLettersPresenter';

function AppliedLettersController() {
  return <AppliedLettersPresenter />;
}

export default AppliedLettersController;
